export class ConstantValues {
// Menu Tracker Retail Constants
  public static ID_MENU_MANAGE_TAGS: number = 1;
  public static ID_MENU_CYCLE_COUNT: number = 2;
  public static ID_MENU_IDENTIFY_TAGS: number = 3;
  public static ID_MENU_LOCATE_ITEMS: number = 4;
  public static ID_MENU_TASKS:number=8;
  public static ID_MENU_EXIT: number = 100;
  public static ID_MENU_LOGOUT: number = 80;
  public static ID_MENU_BACK: number = 70;
  public static ID_MENU_PAIR_DEVICE: number = 13;
//public static Sub Menu Tracker Retail
  public static ID_MENU_SUB_MANAGE_TAGS: number = 11;
  public static ID_MENU_SUB_CHANGE_STATUS: number = 12;
  public static ID_MENU_SUB_FIND_ITEM: number = 5;
  public static ID_MENU_SUB_LOOKUP: number = 13;
  public static ID_MENU_SUB_UNASSOCIATED_TAGS: number = 6;
  public static ID_MENU_SUB_FIND_VIA_PICKLIST: number = 7;
  public static ID_SUB_MENU_REPLENISHMENT: number = 9;
  public static ID_MENU_SUB_DRESSING_ROOM: number = 10;
  public static ID_MENU_SUB_ENCODE_TAGS: number = 14;

}



// WEBPACK FOOTER //
// ./src/pages/menu-tracker-retail/menu-tracker-retail.constants.ts